export const QuickbooksReportConstants = {
    DEFAULT_FILENAME: 'EWA_Quickbooks_Report.xlsx',
} as const;
